import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[validadeMask]',
  standalone: false
})
export class ValidadeMaskDirective {
  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const input = event.target;
    let value = input.value.replace(/\D/g, '').substring(0, 4);

    if (value.length >= 3) {
      value = `${value.slice(0, 2)}/${value.slice(2)}`;
    }

    input.value = value;
  }
}